import './index.scss'

const LoadingBar = () => (
  <div className="LoadingBar">
    <div className="LoadingBar__load" />
  </div>
)

export default LoadingBar
